// extracted by mini-css-extract-plugin
export default {"secondaryButton":"SecondaryButton_secondaryButton__cbbBG","disabled":"SecondaryButton_disabled__Vk-Sv"};